module.exports = __webpack_public_path__ + "img/sort-down.1469411f.svg";